<template>
    <div class="admins">
        <div class="main" >
            <i class="icon beerFamily beer-icon-thirduser"></i>
            <span class="el-dropdown-link">
                Admin<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
        </div>
        <div class="admindown">
            <div>修改密码</div>
            <div>用户信息</div>
            <div  @click="logout()">退出平台</div>
        </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    }
  }

}
</script>
<style lang="less" scoped>
.admins{
    height: 100%;
    position: relative;
    &:hover{
        background: #ececec;
        .admindown{
            display: block;
        }
    }
    .main{
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        height: 100%;
        width: 100%;
    }
    .admindown{
        display: none;
        position: absolute;
        top: 50px;
        background: #fff;
        width: 100%;
        text-align: center;
        padding: 5px 0;
        box-shadow: #ececec  0px 0px 10px;
        div{
            padding: 5px 10px;
            &:hover{
                background: #ececec;
                color: #0079fe
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/Admindrow.vue